var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" EAN: "+_vm._s(_vm.ean)+" - Preis: "+_vm._s(_vm.price)+" "),_c('b-button',{staticClass:"mr-2",attrs:{"variant":"outline-danger"},on:{"click":_vm.onClick}},[_vm._v(" Delete item ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }